import React, { ReactElement } from "react";
import styles from "./Dummy.module.css";

export const NotFound = (): ReactElement => (
  <div className={styles.notFound}>404</div>
);
